export interface StorageResourceLocation {
  key: string;
}
